import { Button } from "components/Button";
import { SortableTable } from "components/SortableTable/SortableTable";
import { StyledCell, StyledHeaderCell } from "components/SortableTable/SortableTable.styled";
import styled from "styled-components/macro";

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.palette.neutral.black};
`;

export const StyledBundleTable = styled(SortableTable)`
  margin: 0;
  border-radius: 0.4rem;

  ${StyledHeaderCell} {
    padding: 1rem;
    padding-top: 0;
    border-bottom: 1px solid ${(props) => props.theme.palette.neutral._900};
    background: ${({ theme }) => theme.palette.neutral.white};
  }

  ${StyledCell} {
    padding: 1rem;
  }
`;
